import { format, formatDistanceToNow } from 'date-fns'
import { getLocale } from './utility'

function timestampToDate(html: string) {
    if (html.startsWith('timestamp')) {
        html = html.substring(9)
    }
    return new Date(parseInt(html))
}

export function replacePublicationTimeValues() {
    const elements = document.getElementsByClassName('publication-time')

    for (let i = 0; i < elements.length; i++) {
        const element = elements[i] as HTMLElement
        const classList = element.classList
        const isListingPage = classList.contains('listing')

        const hidden = isListingPage
            ? 'hidden' === window.noticeable.publicationListTime
            : 'hidden' === window.noticeable.publicationTime

        if (hidden) {
            element.style.display = 'none'
            return
        }

        const relativeToNow = isListingPage
            ? 'relative' === window.noticeable.publicationListTime
            : 'relative' === window.noticeable.publicationTime

        if (relativeToNow) {
            try {
                elements[i].innerHTML = formatDistanceToNow(timestampToDate(elements[i].innerHTML), {
                    addSuffix: true,
                    locale: getLocale(),
                })
            } catch (e) {
                console.error('Error parsing date:', elements[i].innerHTML)
            }
        } else {
            try {
                const pattern = isListingPage
                    ? window.noticeable.publicationListTimePattern
                    : window.noticeable.publicationTimePattern
                elements[i].innerHTML = format(timestampToDate(elements[i].innerHTML), pattern ? pattern : 'PPPp', {
                    locale: getLocale(),
                })
            } catch (e) {
                console.error('Error parsing date:', elements[i].innerHTML)
            }
        }

        element.style.visibility = 'visible'
    }
}
